<template>
  <div class="table-fields">
    <div class="tr">
      <div class="td w-40">
        <i class="fa fa-check-square-o" v-if="tableIsResolved || !tableData[tableKey].length"></i>

        <div class="form-check form-check-inline mr-0" v-else>
          <input type="checkbox" class="form-check-input" :value="tableId"
                 @change="$emit('selected-table-change', tableKey, tableId, isSelectedTable)"
                 v-model="isSelectedTable">
        </div>
      </div>
      <div class="td">
        <div class="table-fields" v-if="tableData[tableKey].length > 0">
          <div class="tr-header">
            <div class="td" v-for="header in table.header">{{ header }}</div>
          </div>
          <div class="tr" v-for="values in tableData[tableKey]">
            <div v-show="k !== 'id'" class="td" v-for="(value, k) in values">{{ value }}</div>
          </div>
        </div>
        <div v-else>
          {{ table['no-data-message'] }}
        </div>
      </div>
    </div>
  </div>

</template>

<script>

export default {
  emits: [
    'selected-table-change'
  ],

  props: {
    table: {
      type: Object,
      required: true
    },

    tableKey: {
      type: String,
      required: true
    },

    tableId: {
      type: Number,
      required: true,
    },

    tableData: {
      type: Object,
      required: true,
    },

    tableIsResolved: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      isSelectedTable: false,
    };
  },
}
</script>

<style scoped>

.w-40 {
  width: 40px;
}

.table-fields {
  display: table;
  width: 100%;
}

.tr-header {
  display: table-row;
  font-weight: bold;
}

.tr {
  display: table-row;
}

.td {
  display: table-cell;
  padding: 5px;
}

del, ins {
  padding: 2px 5px;
  border-radius: 5px;
}

</style>
